// ─────────────────────────────────────────────
//  ProductCard.jsx — Tarjeta de producto
// ─────────────────────────────────────────────

import React from 'react';
import styles from './ProductCard.module.css';

function sanitize(val) {
	let v = val.replace(/[^0-9.]/g, '');
	const parts = v.split('.');
	if (parts.length > 2) v = parts[0] + '.' + parts.slice(1).join('');
	if (parts[1] !== undefined && parts[1].length > 4) {
		v = parts[0] + '.' + parts[1].slice(0, 4);
	}
	return v;
}

export default function ProductCard({
	product,
	colors,
	price,
	qty,
	unit,
	onPriceChange,
	onQtyChange,
	winner,
	loser,
	savingsPct,
	hasData,
	onRemove,
}) {
	const { dot } = colors;
	const showWinner = hasData && winner;
	const showLoser  = hasData && loser && savingsPct > 0;

	return (
		<article
			className={`${styles.card} ${showWinner ? styles.winner : ''}`}
			style={{ '--dot': dot }}
			aria-label={`Producto ${product}${showWinner ? ', mejor precio' : ''}`}
		>
			<div className={styles.cardHeader}>
				<span className={styles.productLetter} style={{ color: dot }}>
					{product}
				</span>
				<span className={styles.cardLabel}>&nbsp; Producto {product}</span>

				{showWinner && (
					<span className={styles.badgeWinner}>
						✓ Mejor precio
					</span>
				)}
				{showLoser && (
					<span className={styles.badgeLoser}>
						{savingsPct.toFixed(0)}% más caro
					</span>
				)}

				{onRemove && (
					<button
						type="button"
						className={styles.removeBtn}
						onClick={onRemove}
						aria-label={`Eliminar Producto ${product}`}
					>
						✕
					</button>
				)}
			</div>

			<div className={styles.inputRow}>
				<div className={styles.inputCell}>
					<p className={styles.inputCellLabel}>Precio</p>
					<div className={styles.inputMock}>
						<span className={styles.inputCurrency} aria-hidden="true">$</span>
						<input
							className={styles.inputValue}
							style={{ '--accent': dot }}
							type="text"
							inputMode="decimal"
							value={price}
							onChange={(e) => onPriceChange(sanitize(e.target.value))}
							placeholder="0"
							aria-label={`Precio del producto ${product}`}
						/>
					</div>
				</div>

				<div className={styles.inputCell}>
					<p className={styles.inputCellLabel}>Cantidad</p>
					<div className={styles.inputMock}>
						<input
							className={styles.inputValue}
							style={{ '--accent': dot }}
							type="text"
							inputMode="decimal"
							value={qty}
							onChange={(e) => onQtyChange(sanitize(e.target.value))}
							placeholder="0"
							aria-label={`Cantidad del producto ${product}`}
						/>
						<span className={styles.inputUnit}>{unit}</span>
					</div>
				</div>
			</div>
		</article>
	);
}
